<div>
    <rwidget-alert></rwidget-alert>
    <div
        class="sr-app-light:visible vl-app-light:visible border-b border-solid border-opacity-10 bg-[var(--color-panel)] py-2 md:invisible">
        <div class="flex flex-row items-center justify-between">
            <ion-button
                [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                (click)="handleBackClicked()"
                color="secondary"
                fill="clear">
                <ion-icon
                    class="mr-1 text-xl dark:filter-yellow"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg">
                </ion-icon>
            </ion-button>
            <h1 class="text-base font-bold leading-5">
                {{ 'NOTIFICATION_SETTINGS_SIDE_TITLE' | translate }}
            </h1>
            <div class="w-12"></div>
        </div>
    </div>

    <div class="px-4" *ngIf="this.env.APP_NOTIFICATIONS?.SHOW_REDIRECT_TO_OS_SETTINGS">
        <a
            class="flex h-14 w-full items-center justify-between text-base text-black dark:text-contrast-yellow"
            (click)="openOsNotificationSettings()">
            {{ 'OPEN_OS_NOTIFICATION_SETTINGS' | translate }}
            <ion-icon
                class="text-[1.5rem] text-black dark:text-contrast-yellow"
                name="open-outline"
                aria-hidden="true"></ion-icon>
        </a>
    </div>

    <div
        class="flex-column flex-justify-center vl-app-light:flex-col vl-app-light:m-0 sr-app-light:m-0 sr-app-light:flex-col flex shadow md:m-4 md:flex-row"
        *ngIf="!this.env.APP_NOTIFICATIONS?.HIDE_IN_APP_TOGGLE"
        [class.block--wrap]="!this.env.IS_MOBILE_APP">
        <div
            class="vl-app-light:hidden sr-app-light:hidden basis-2/6 bg-[var(--color-panel)] p-4 shadow"
            [class.mb-4]="this.env.IS_MOBILE_APP">
            <h1
                class="mb-1 hidden md:block md:justify-start md:text-3xl md:font-normal"
                *ngIf="!this.env.IS_MOBILE_APP">
                {{ 'NOTIFICATION_SETTINGS_SIDE_TITLE' | translate }}
            </h1>
            <p>
                {{ 'NOTIFICATION_SETTINGS_SIDE_TITLE_DESCRIPTION' | translate }}
            </p>
        </div>
        <div class="basis-4/6" [class.mt-6]="env.NOTIFICATION_CHANNELS?.length === 1">
            <div class="rounded-none bg-[var(--color-panel)] px-0 py-2" *ngIf="env.NOTIFICATION_CHANNELS?.length">
                <div class="p-4 sm:p-6">
                    <ul class="m-0 list-none p-0" *ngIf="env.NOTIFICATION_CHANNELS?.length > 1">
                        <li class="mb-2 flex items-center justify-between text-sm font-bold uppercase">
                            <label for="toggle-all">{{ 'NOTIFICATION_SETTINGS_TOGGLE_ALL' | translate }}</label>
                            <mat-slide-toggle
                                class="mr-6"
                                id="toggle-all"
                                [checked]="isAnyChecked()"
                                (change)="toggleAll()"></mat-slide-toggle>
                        </li>
                        <div class="rounded-lg bg-gray-100 p-4 dark:bg-transparent">
                            <li
                                class="mb-2 flex items-center justify-between"
                                *ngFor="let channel of env.NOTIFICATION_CHANNELS">
                                <label class="ml-4" for="{{ channel }}">
                                    {{ 'NOTIFICATION_SETTINGS_TOGGLE_' + (channel | uppercase) | translate }}
                                </label>
                                <mat-slide-toggle
                                    class="mr-2"
                                    id="{{ channel }}"
                                    [(ngModel)]="notificationSettings?.channels[channel]"
                                    (change)="updateNotificationSettings()">
                                </mat-slide-toggle>
                            </li>
                        </div>
                    </ul>
                    <div class="flex items-center justify-between" *ngIf="env.NOTIFICATION_CHANNELS?.length === 1">
                        <label
                            class="ml-4 text-sm font-bold text-grey-zambezy dark:text-contrast-yellow"
                            for="{{ env.NOTIFICATION_CHANNELS[0] }}">
                            {{
                                'NOTIFICATION_SETTINGS_TOGGLE_' + (env.NOTIFICATION_CHANNELS[0] | uppercase) | translate
                            }}
                        </label>
                        <mat-slide-toggle
                            class="toggle-slide mr-2"
                            id="{{ env.NOTIFICATION_CHANNELS[0] }}"
                            #singleToggle
                            [(ngModel)]="notificationSettings.channels[env.NOTIFICATION_CHANNELS[0]]"
                            [class.toggle-slide-sr]="showToggleSlideStyle"
                            (change)="updateNotificationSettings()">
                        </mat-slide-toggle>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
